<button *ngIf="visible"
    class="btn-audio btn-left" 
    (click)="back()"
    [class.disabled]="disabled === true">
        <fa-icon [icon]="faArrowLeft"></fa-icon>
</button>